import { h, Component, render } from 'preact';
import { Subject } from 'rxjs';
import cx from 'classnames'

import hopplerLinkState, { hopplerUpdateFormFieldValue } from '../../../utils/forms/hoppler-linkstate';
import { HopplerMultiCheckbox } from '../common/hopper-multi-checkbox.component';
import { Form } from '../../../utils/forms/form';
import { debounce } from '../../../utils/debounce';
import { LocationFilterItem } from '../../../../types/location.model';
import { locationService } from '../../../utils/location.service';
import { PropertyDivision } from '../../../../types/div-cat.model';
import { residentialPropTypes, commercialPropTypes, propertyTypes, PropertyTypeListItem } from '../../../../constants';
import { DatePickerControl } from '../common/date-picker-control.component';
import { FormattedNumberInput } from '../common/formatted-number-input.component';

interface ListingFilterCardProps {
  clearing?: boolean;
  formSubject?: Subject<Form>;
  filterForm?: Form;
  onFilterCloseClick?: any;
  onClearFiltersClicked?: any;
  onFilterSearchClicked?: (e: Event) => void;
};

interface ListingFilterCardState {
  locationText?: string;
  isFetching?: boolean;
  hasNoResult?: boolean;
  optionsAreVisible?: boolean;
  locationFilterItems?: LocationFilterItem[];
};

export class ListingFilterCard extends Component<ListingFilterCardProps, ListingFilterCardState> {

  constructor(props) {
    super(props);

    this.state = {
      locationText: '',
      optionsAreVisible: false,
      isFetching: false,
      locationFilterItems: [],
      hasNoResult: false,
    }    
  }

  getLocations = async (location: string) => {
    this.setState({ isFetching: true })

    try {
      const res = await locationService.filterLocation(location)

      if (res.data.results) {
        this.setState({
          isFetching: false,
          optionsAreVisible: true,
          locationFilterItems: res.data.results,
        })
      } else {
        this.setState({
          isFetching: false,
          hasNoResult: true,
          optionsAreVisible: true,
          locationFilterItems: []
        })
      }

    } catch (error) {
      console.log(error)
    }
  }

  handleOptionSelect = (item: LocationFilterItem) => {
    const { filterForm } = this.props;
    filterForm.fields['locationId'].value = item.uId;

    this.setState({
      locationText: item.label,
      optionsAreVisible: false
    })
  }

  handleLocationInputClick = () => {
    const { locationFilterItems } = this.state;

    if (locationFilterItems.length > 0) {
      this.setState({ optionsAreVisible: true })
    }
  }

  handleLocationInputChange = debounce((e) => {
    const value = e.target.value;
    this.setState({ locationText: value })

    if (value.length >= 3) {
      this.setState({ 
        hasNoResult: false,
      })
  
      this.getLocations(value);
      
    } else {
      this.setState({
        optionsAreVisible: false
      })
    }
  }, 500)

  handleClearBtnClick = () => {
    this.props.onClearFiltersClicked();
    this.setState({
      locationText: ''
    })
  }

  getFilterPropTypes() {
    const props = this.props;
    let form = props.filterForm;
    let selectedPropertyTypes: PropertyTypeListItem[];
    const selectedDivision = form.fields['division'].value as PropertyDivision;

    if (selectedDivision == 'Residential') {
      selectedPropertyTypes = residentialPropTypes;
    } else if (selectedDivision == 'Commercial') {
      selectedPropertyTypes = commercialPropTypes;
    } else {
      selectedPropertyTypes = propertyTypes;
    }

    return (
      <select className="form-control" value={ form.fields['type'].value }
        onChange={ hopplerLinkState(props.formSubject, props.filterForm, 'type') }>
        <option className="text-muted" value="" disabled={true} selected>Choose Type</option>
        {
          selectedPropertyTypes.map((option) =>
            <option value={ option.label }>
              { option.label }
            </option>
          )
        }
      </select>
    );
  }

  render(props: ListingFilterCardProps, state: ListingFilterCardState) {
    const { filterForm } = this.props;
    const form$ = props.formSubject;

    const {
      locationText,
      isFetching,
      optionsAreVisible,
      locationFilterItems,
      hasNoResult
    } = this.state;

    return (
      <div>
        <div className="hi-dash-listings__filters-block hi-listing-filter">
          <div className="hi-dash-listings__filters-block__top container-fluid">
            <div className="row h-100 align-items-center">
              <div className="col-4 d-none d-md-block">
                <h3 className="hi-dash-listings__filters-block__top__h3 mb-0">
                  Set filter
                </h3>
              </div>
              <div className="col-8 hi-dash-listings__filters-block-header-btns">
                <div className="d-flex justify-content-end">
                  <button 
                    disabled={ props.clearing }
                    onClick={ this.handleClearBtnClick } 
                    className="btn btn-light bg-transparent px-3 mr-3">
                    { props.clearing ? 'Clearing...' : 'Clear Filters' }
                  </button>

                  <button
                    className="btn btn-light bg-transparent px-3"
                    onClick={ props.onFilterCloseClick }>
                    Close
                  </button>
                </div>

              </div>
            </div>
          </div>
          <div className="hi-dash-listings__filters-block__body container-fluid">

            <div className="row mt-4">
              <div className="col-12">
                {/* <input className="form-control hi-text-input"
                  placeholder="Location"
                  type="text"
                  value={ filterForm.fields.location.value }
                  onInput={ hopplerLinkState(formSubject, filterForm, 'location') }/> */}
                <label className="hi-listing-editor-modal__editor__label">
                  Location
                </label>
                  
                <div className="input-group hi-listing-filter__location-input">
                  <input 
                    value={ locationText }
                    placeholder="Search Location"
                    type="text"
                    className="form-control hi-text-input"
                    onFocus={ this.handleLocationInputClick }
                    onInput={ this.handleLocationInputChange }
                  />
                  
                  {
                    isFetching && (
                      <div
                        className="spinner-border spinner-border-sm text-muted location-spinner" 
                        role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    )
                  }
                  
                  <div className={ cx('location-options', {
                    'd-none': !optionsAreVisible || !locationText
                  }) }>

                    { hasNoResult && (
                      <p className="text-muted text-center py-2 mb-0">No location found.</p>
                    ) }

                    {
                      locationFilterItems.map(item => (
                        <div
                          onClick={ () => this.handleOptionSelect(item) } 
                          className="location-options__item">
                          <p className="label">{ item.label }</p>
                          <p className="level">{ item.level }</p>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12">
                <label className="hi-listing-editor-modal__editor__label">
                  Property Kind
                </label>

                <div className="row mx-0">
              
                  <span className={ cx('hi-input-radio-toggle col-6', 
                      {
                        active: filterForm.fields['division'].value == 'Residential'
                      })
                    }>
                    <label>
                      <input className="first" type="radio" name="propertyType" 
                        value="Residential"
                        onClick={ hopplerLinkState(form$, filterForm, 'division') }/>
                      Residential
                    </label>
                  </span>
                  <span className={ cx('hi-input-radio-toggle col-6', 
                      {
                        active: filterForm.fields['division'].value == 'Commercial'
                      })
                    }>
                    <label>
                      <input className="first" type="radio" name="propertyType"
                        value="Commercial"
                        onClick={ hopplerLinkState(form$, filterForm, 'division') }/>
                      Commercial
                    </label>
                  </span>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12">
                <label className="hi-listing-editor-modal__editor__label">
                  Category
                </label>                
              
                <div className="row mx-0">
                  <span className={ cx('hi-input-radio-toggle col-6', 
                      {
                        active: filterForm.fields['category'].value == 'Rent'
                      })
                    }>
                    <label>
                      <input className="first" type="radio" name="category"
                        value="Rent"
                        onClick={ hopplerLinkState(form$, filterForm, 'category') }/>
                      For rent
                    </label>
                  </span>
                  <span className={ cx('hi-input-radio-toggle col-6', 
                      {
                        active: filterForm.fields['category'].value == 'Sale'
                      })
                    }>
                    <label>
                      <input className="first" type="radio" name="category" 
                        value="Sale"
                        onClick={ hopplerLinkState(form$, filterForm, 'category') }/>
                      For sale
                    </label>
                  </span>
                </div>   
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12">
                <label className="hi-input-group__label">Property Type</label>
                { this.getFilterPropTypes() }
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12">
                <label className="hi-input-group__label">Property Source</label>
                <select className="form-control"
                  value={ filterForm.fields.source.value }
                  onChange={ hopplerLinkState(form$, filterForm, 'source') }>
                  <option value="Any">Any</option>
                  <option value="Direct">Direct</option>
                  <option value="Network">Network</option>
                </select>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12">
                <label className="hi-input-group__label">Price</label>
                <div className="d-flex">
                  <FormattedNumberInput type="number" className="form-control w-50 hi-border-radius-right-0" placeholder="Min"
                    value={ filterForm.fields.minPrice.value }
                    onChange={ hopplerLinkState(form$, filterForm, 'minPrice') } />
                  <FormattedNumberInput type="number" className="form-control w-50 hi-border-radius-left-0" placeholder="Max"
                    value={ filterForm.fields.maxPrice.value }
                    onChange={ hopplerLinkState(form$, filterForm, 'maxPrice') } />
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12">
                <label className="hi-input-group__label">Lot Size</label>
                <div className="d-flex">
                <FormattedNumberInput type="number" className="form-control w-50 hi-border-radius-right-0" placeholder="Min"
                  value={ filterForm.fields.minLotArea.value }
                  onChange={ hopplerLinkState(form$, filterForm, 'minLotArea') } />
                <FormattedNumberInput type="number" className="form-control w-50 hi-border-radius-left-0" placeholder="Max"
                  value={ filterForm.fields.maxLotArea.value }
                  onChange={ hopplerLinkState(form$, filterForm, 'maxLotArea') } />
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12">
                <label className="hi-input-group__label">Floor Size</label>
                <div className="d-flex">
                <FormattedNumberInput type="number" className="form-control w-50 hi-border-radius-right-0" placeholder="Min"
                  value={ filterForm.fields.minFloorArea.value }
                  onChange={ hopplerLinkState(form$, filterForm, 'minFloorArea') } />
                <FormattedNumberInput type="number" className="form-control w-50 hi-border-radius-left-0" placeholder="Max"
                  value={ filterForm.fields.maxFloorArea.value }
                  onChange={ hopplerLinkState(form$, filterForm, 'maxFloorArea') } />
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12">
                <div className="hi-input-group">
                  <label className="hi-input-group__label">Bedrooms</label>
                  <HopplerMultiCheckbox
                    choices={[
                      { value: '0', label: 'Studio' },
                      { value: '1' },
                      { value: '2' },
                      { value: '3' },
                      { value: '4' },
                      { value: '5', label: '5+' },
                    ]}
                    value={ filterForm.fields.bedrooms.value }
                    valueChange={ value => hopplerUpdateFormFieldValue(form$, this.props.filterForm, 'bedrooms', value) } />
                    {/*
                      Above NEEDS to be this.props.filterForm. If we use
                      filterForm or props.filterForm, all fields except this
                      lose their values.

                      Need to figure out why this broke, and why this is
                      fixed by the above change. Updates to props that don't
                      cause re-renders *could* be a factor.
                    */}
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12">
                <div className="hi-input-group">
                  <label className="hi-input-group__label">Bathroom</label>
                  <HopplerMultiCheckbox
                    choices={[
                      { value: '1' },
                      { value: '2' },
                      { value: '3' },
                      { value: '4' },
                      { value: '5', label: '5+' },
                    ]}
                    value={ filterForm.fields.bathrooms.value }
                    valueChange={ value => hopplerUpdateFormFieldValue(form$, this.props.filterForm, 'bathrooms', value) } />
                    {/*
                      Above NEEDS to be this.state.filterForm. If we use
                      filterForm or state.filterForm, all fields except this
                      lose their values.

                      Need to figure out why this broke, and why this is
                      fixed by the above change.
                    */}
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12">
                <div className="hi-input-group">
                  <label className="hi-input-group__label">Alternate Contact</label>
                  <input 
                    type="text"
                    className="form-control"
                    placeholder="Alternative contact"
                    value={ filterForm.fields.alternate.value }
                    onChange={ hopplerLinkState(form$, filterForm, 'alternate') } />
                </div>
              </div>

              <div className="col-12 mt-4">
                <div className="hi-input-group">
                  <label className="hi-input-group__label">Uploader/Contact</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Uploader/contact"
                    value={ filterForm.fields.uploader.value }
                    onChange={ hopplerLinkState(form$, filterForm, 'uploader') } />
                </div>
              </div>

              <div className="col-12 mt-4">
                <div className="hi-input-group">
                  <label className="hi-input-group__label">Sales Director</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Sales director"
                    value={ filterForm.fields.salesDirector.value }
                    onChange={ hopplerLinkState(form$, filterForm, 'salesDirector') } />
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12">
                <label className="hi-input-group__label">Date Modified</label>
                <div className="d-flex">
                  <DatePickerControl className="w-50 form-control  hi-border-radius-right-0"
                    name="dateModifiedFrom" aria-label="Date Modified, from"
                    value={ filterForm.fields.dateModifiedFrom.value }
                    max={ filterForm.fields.dateModifiedTo.value }
                    onChange={ hopplerLinkState(form$, filterForm, 'dateModifiedFrom') } />
                  <DatePickerControl className="w-50 form-control  hi-border-radius-left-0"
                    name="dateModifiedTo" aria-label="Date Modified, to"
                    value={ filterForm.fields.dateModifiedTo.value }
                    min={ filterForm.fields.dateModifiedFrom.value }
                    onChange={ hopplerLinkState(form$, filterForm, 'dateModifiedTo') } />
                </div>
              </div>
            </div>


            <div className="row mt-4">
              <div className="col-12">
                <label className="hi-input-group__label">Expires</label>
                <div className="d-flex">
                  <DatePickerControl className="w-50 form-control hi-border-radius-right-0"
                    name="dateExpiresFrom" aria-label="Date Expires, from"
                    value={ filterForm.fields.dateExpiresFrom.value }
                    max={ filterForm.fields.dateExpiresTo.value }
                    onChange={ hopplerLinkState(form$, filterForm, 'dateExpiresFrom') } />
                  <DatePickerControl className="w-50 form-control hi-border-radius-left-0"
                    name="dateExpiresTo" aria-label="Date Expires, to"
                    value={ filterForm.fields.dateExpiresTo.value }
                    min={ filterForm.fields.dateExpiresFrom.value }
                    onChange={ hopplerLinkState(form$, filterForm, 'dateExpiresTo') } />
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12">
                <label className="hi-input-group__label">Upload Date</label>
                <div className="d-flex">
                  <DatePickerControl className="w-50 form-control hi-border-radius-right-0"
                    name="dateCreatedFrom" aria-label="Date Created, from"
                    value={ filterForm.fields.dateCreatedFrom.value }
                    max={ filterForm.fields.dateCreatedTo.value }
                    onChange={ hopplerLinkState(form$, filterForm, 'dateCreatedFrom') } />
                  <DatePickerControl className="w-50 form-control hi-border-radius-left-0"
                    name="dateCreatedTo" aria-label="Date Created, to"
                    value={ filterForm.fields.dateCreatedTo.value }
                    min={ filterForm.fields.dateCreatedFrom.value }
                    onChange={ hopplerLinkState(form$, filterForm, 'dateCreatedTo') } />
                </div>
              </div>
            </div>

            {/*
              mt-1 prevents the DatePickerControl bottom borders from being
              overlapped by the button row
            */}
            <div className="row mt-1 hi-listing-filter__button-row">
              <div className="col-12">
                <button className="btn btn-secondary w-100" onClick={ e => props.onFilterSearchClicked(e) }>
                  Search
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
          
    )
  }
}